<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0 ; height:auto !important">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-cell-group>   

                <van-cell title="队伍照片" :value="formData.heying.length+'/1'">
                    <!--<template slot="icon" >-->
                        <!--<van-icon class="question-icon" name="question-o" @click="onQuestion('heying')"/>-->
                    <!--</template>-->
                </van-cell>

                <div class="row">
                    <PicUploader2 :fileList="formData.heying" @imageListChange="heyingChange" :limit="1"
                                 :name="'heying'"></PicUploader2>
                </div>
                <div class="operate-desc-left">上传一张队伍照片(横版),建议比例3x4</div>
 


            </van-cell-group>


            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">下一步</van-button>
            </div>
        </van-form>


        <CaipanPicker
                :show="showCaipanPicker"
                :limit="1"
                :danweiId="formData.danwei_id"
                @onChange="onCaipanChange"
                @onClose="showCaipanPicker=false"
                :defaultValue="formData.caipan"
                @onConfirm="onCaipanConfirm"
        ></CaipanPicker>


        <JiaolianPicker
                :show="showJiaolianPicker"
                :limit="5"
                :danweiId="formData.danwei_id"
                @onChange="onJiaolianChange"
                @onClose="showJiaolianPicker=false"
                :defaultValue="formData.jiaolian"
                @onConfirm="onJiaolianConfirm"
        ></JiaolianPicker>

        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        height: 36px;
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader2 from '@/components/picker/PicUploader2.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon,Dialog, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';
    import LoginDialog from '@/components/LoginDialog.vue';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Dialog).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep1',
        components: {
            [Field.name]: Field,
            PicUploader2,
            CaipanPicker,
            JiaolianPicker,
            LoginDialog
        },
        data: function () {
            return {
                validator,
                loginShow:false,
                saveLoading:false,
                saiqu_id: this.$route.query.saiqu_id,
                showCaipanPicker:false,
                showJiaolianPicker:false,
                showNumTypePicker:false,
                numTypeColumns: ['身份证', '护照', '其他'],
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                formData: {
                    id:0,
                    saiqu_name:'',
                    numTypeName:'身份证',
                    danwei:'',
                    mingcheng:'',
                    mingcheng_end:'',
                    ldcardtype:1,
                    ldsex:1,
                    danwei_options:[],
                    heying: [],
//                            [{name:"选择商户.png",
//                        save_name:"h5/2020-05-11/1589187988243621.png",
//                        uid:"vc-upload-1589187988243621",
//                        url:"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-11/1589187988243621.png"
//                    }],
                    caipan:[],
                    jiaolian:[],
                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
            document.title = '秩序册填写';
            // this.fetch1();
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {

            fetch1(){
                let that = this;
                that.$api.get('/api/isai/step1Detail', {
                    saiqu_id : that.saiqu_id,
                    id : that.formData.id,
                }, (res) => { 
                    if(res.data.notice){
                        Dialog.confirm({
                        title: '报名须知',
                        message: res.data.notice,
                        confirmButtonText:'同意并开始报名',
                        cancelButtonText:'不报名了'
                        }).then(() => {
                        // on close
                            that.fetch();
                        }).catch(() => {
                            rbLink({
                                name:'',
                            },'back')
                        });;
                        return ;
                    }else{
                        that.fetch();
                    }

                },(res) =>{

                    console.log('没有登录');
                    if (res.code == 401 || res.code==402) {
                        if(window.isApp()){
                            rbLink({
                                name:'login','query':{ }
                            },'replace');
                            return false;
                        }
                        that.loginShow = true
                    }else {
                        Toast(res.msg)
                    }
                })
            },
            fetch(){
                let that = this;
                that.$api.get('/api/isai/step1Detail', {
                    saiqu_id : that.saiqu_id,
                    id : that.formData.id,
                }, (res) => {
                    that.formData = Object.assign(that.formData, res.data);

                    if(that.formData.danwei_status==0){
                        Dialog.alert({
                            title: '请先认证',
                            message: '报名前请先进行单位信息的备案或者绑定',
                            confirmButtonText:'进行单位认证或绑定'
                        }).then(() => {
                            // on close
                            rbLink({
                                name:'CertDanwei'
                            })
                        });
                    }else if(that.formData.danwei_status==1){
                        Dialog.alert({
                            title: '请等待认证审核',
                            message: '您的单位信息正在审核请耐心等待审核通过',
                            confirmButtonText:'查看详情'
                        }).then(() => {
                            // on close
                            rbLink({
                                name:'CertDanweiResult'
                            })
                        });
                    }else if(that.formData.danwei_status==3){
                        Dialog.alert({
                            title: '单位认证未通过',
                            message: '您的单位信息未通过审核',
                            confirmButtonText:'查看详情'
                        }).then(() => {
                            // on close
                            rbLink({
                                name:'CertDanweiResult'
                            })
                        });
                    }else if(that.formData.jiaolian_count==0){
                        Dialog.alert({
                            title: '没有注册教练员信息',
                            message: '请先注册教练员信息',
                            confirmButtonText:'立即注册'
                        }).then(() => {
                            // on close
                            rbLink({
                                name:'JiaolianList'
                            })
                        });
                    }else if(that.formData.un_complete>0){
                        Dialog.setDefaultOptions({
                            'confirmButtonText':'继续未完成的报名',
                            'cancelButtonText':'重新报名',
                        })
                        Dialog.confirm({
                            title: '您有未完成的报名',
                            message: '建议您选择继续未完成的报名'
                        }).then(() => {
                            that.jumToOld();
                        }).catch(() => {
                        });
                    }


                },(res) =>{
                    console.log('没有登录');
                    if (res.code == 401 || res.code==402) {
                        if(window.isApp()){
                            rbLink({
                                name:'login','query':{ }
                            },'replace');
                            return false;
                        }
                        that.loginShow = true
                    }else { 
                        Toast({
                        message: '啦啦之星提示您:'+res.msg,
                        iconSize:'300px',
                        icon: 'https://api.ccachina.net/public/images/icon-lalazhixing.png',
                        });
                    }
                })
            },
            onQuestion(){
                console.log('onQuestion')
            },
            onCaipanConfirm(values){
                console.log('onCaipanConfirm',values)
                this.showCaipanPicker = false;
                this.formData.caipan = [...values];
            },
            onCaipanChange(values){
                console.log('onCaipanChange',values)
                this.formData.caipan = [...values];
            },
            onCaipanConfirm(values){
                console.log('onCaipanConfirm',values)
                this.showCaipanPicker = false;
                this.formData.caipan = [...values];
            },
            onCaipanChange(values){
                console.log('onCaipanChange',values)
                this.formData.caipan = [...values];
            },
            onJiaolianConfirm(values){
                console.log('onJiaolianConfirm',values)
                this.showJiaolianPicker = false;
                this.formData.jiaolian = [...values];
            },
            onJiaolianChange(values){
                console.log('onJiaolianChange',values)
                this.formData.jiaolian = [...values];
            },
            onNumTypeConfirm(value, index){
                this.formData.numTypeName = value;
                this.formData.ldcardtype = index+1;
                this.showNumTypePicker = false;
            },
            jumToOld(id){
                rbLink({
                    name:'ISaiApplyList'
                },'replace')
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                    if (that.formData.heying.length == 0) {
                        Toast('请上传队伍照片');
                        return
                    }
                    if (this.formData.jiaolian.length==0) {
                        Toast('请至少选择一位教练');
                        return
                    }
                }
                that.saveLoading = true;
                that.$api.post('/api/isai/baoming', that.formData, (res) => {
                    that.saveLoading = false;

                    appEvent({
                        name: 'saiApplyDetailReload',
                        query: {
                        }
                    });
                    setTimeout(function () {
                        rbLink({
                            'name' : 'ISaiApplyDetail',
                            'query':{
                                id:res.data.id
                            }
                        },'replace')
                    },50);
                }, (res) => {
                    if(res.code == 505){
                        Dialog.alert({
                            title: '等待认证',
                            message: res.msg,
                            confirmButtonText:'查看详情'
                        }).then(() => {
                            // on close
                            rbLink({
                                name:'CertDanwei'
                            })
                        });
                    }else{
                        Toast.fail(res.msg);
                    }
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },

            loginSuccess(res){
                console.log('-------登录成功--------',res);
                this.loginShow = false;
                this.fetch();
            },

            loginCancel(){
                console.log('-------取消登录--------');
                // this.loginShow = false;
            },
            heyingChange(data){
                console.log('heying',data);
                let that = this;
                if(data.pic.length>0){
                    // 创建对象
                    var img = new Image(); 
                    // 改变图片的src
                    img.src = data.pic[0].url; 
                    // 打印
                    img.onload = function(){
                        // 打印
                        if(img.width<img.height){ 
                            Toast('请上传横版图片');
                            that.formData.heying =[];
                            return ;
                        } 
                    }
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// Uploadimg.vue?dfc56450